
/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

import { APIClient } from "api/api_helper";
import { REPRINT_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

/* ------------------------------------------------------------------
 * LABEL API
 * ------------------------------------------------------------------ */

export const RePrintApiService = {
    // SELECT ALL LABEL PRINT METHOD
    selectAll: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            printtype: payload_data.printtype,
            searchtext: payload_data.searchtext || null,
            currentpage: payload_data.currentpage || 1,
            pagesize: payload_data.pagesize || 10,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            studyid: payload_data.studyid || null,
        };
        return api.create(REPRINT_LABEL_API.REPRINT_LABEL_API + "SelectAll", payload);
    }
};




;


